import React from "/vendor/react";

import NameSearchBox from "/lib/component/partial/NameSearchBox";

const EntitiesSearchBox = () => (
  <NameSearchBox
    aria-label="Search entities"
    placeholder={"Search entities by name\u2026"}
  />
);

export default EntitiesSearchBox;
